import { render, staticRenderFns } from "./TitleHeader.vue?vue&type=template&id=5e058fe0&"
import script from "./TitleHeader.ts?vue&type=script&lang=ts&"
export * from "./TitleHeader.ts?vue&type=script&lang=ts&"
import style0 from "./TitleHeader.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports